import { useSyncExternalStore } from 'react';
import { isNativePlatform } from '@/utils/capacitor';

type Listener = () => void;

let armed = false;
let settled = true;
let suppressGuestHome = false;
let snapshot = { settled, suppressGuestHome };
const listeners = new Set<Listener>();

function emit(): void {
  snapshot = { settled, suppressGuestHome };
  listeners.forEach((listener) => listener());
}

export function subscribeAppDeepLinkLaunch(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function getAppDeepLinkLaunchSnapshot(): { settled: boolean; suppressGuestHome: boolean } {
  return snapshot;
}

/** Native cold start: GuestOnly must not redirect to home until launch URL is consumed. */
export function armNativeDeepLinkLaunch(): void {
  if (armed) return;
  armed = true;
  settled = false;
  suppressGuestHome = false;
  emit();
}

export function markAppDeepLinkLaunchSettled(): void {
  if (settled) return;
  settled = true;
  emit();
}

/** Keep GuestOnly from replacing a valid cold-start target while still on `/`. */
export function suppressGuestHomeForDeepLink(): void {
  if (suppressGuestHome) return;
  suppressGuestHome = true;
  emit();
}

export function clearGuestHomeDeepLinkSuppress(): void {
  if (!suppressGuestHome) return;
  suppressGuestHome = false;
  emit();
}

export function resetAppDeepLinkLaunchForTests(): void {
  armed = false;
  settled = !isNativePlatform();
  suppressGuestHome = false;
  emit();
}

export function useBlockGuestHomeForDeepLink(): boolean {
  const { settled: launchSettled, suppressGuestHome: suppressHome } = useSyncExternalStore(
    subscribeAppDeepLinkLaunch,
    getAppDeepLinkLaunchSnapshot,
    getAppDeepLinkLaunchSnapshot
  );
  return !launchSettled || suppressHome;
}
